import React from "react";
import TablePagination from "@mui/material/TablePagination";
import {
  GridFooterContainer,
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
  gridRowSelectionStateSelector 
} from "@mui/x-data-grid-pro";
import { Box } from "@mui/material";
import styles from '../../../styles/table/customFooter.module.scss';

const CustomFooter = ({
  isServerMode = false,
  page,
  pageSize,
  rowCount,
  onPageChange = () => {},
  onPageSizeChange = () => {}
}) => {
  const apiRef = useGridApiContext();
  const internalPage = useGridSelector(apiRef, gridPageSelector);
  const internalPageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const internalRowCount = useGridSelector(apiRef, gridRowCountSelector);
  const selectedRows = useGridSelector(apiRef, gridRowSelectionStateSelector);

  // Define the allowed page size options
  const pageSizeOptions = [25, 50, 100];
  
  // Ensure the pageSize is valid; fallback to the first option if not
  const validatedPageSize = pageSizeOptions.includes(pageSize) ? pageSize : pageSizeOptions[0];

  const handlePageChange = (event, newPage) => {
    if (isServerMode) {
      onPageChange(event, newPage);
    } else {
      apiRef.current.setPage(newPage);
    }
  };

  const handleRowsPerPageChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    if (isServerMode) {
      onPageSizeChange(newPageSize);
    } else {
      apiRef.current.setPageSize(newPageSize);
    }
  };

  return (
    <GridFooterContainer
    id="custom-footer"
    className={styles.container}
    >
        <Box 
         sx={{ 
            display: { xs: 'none', sm: 'block' },
            fontSize: '0.875rem',
            ml: 2,
        }}
         >
            {selectedRows.length > 0
            ? `${selectedRows.length} row${selectedRows.length > 1 ? 's' : ''} selected`
            : null}
            
        </Box>

      <TablePagination
        component="div"
        count={isServerMode ? rowCount : internalRowCount}
        page={isServerMode ? page : internalPage}
        onPageChange={handlePageChange}
        rowsPerPage={isServerMode ? validatedPageSize : internalPageSize}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={pageSizeOptions}
        showFirstButton
        showLastButton
        // sx={{
        //   '& .MuiTablePagination-actions > button': {
        //     marginInline: '10px',
        //     color: '#93c5fd',
        //     '&:not(:disabled)': {
        //         color: '#2563eb',
        //     },
        //   },
        //   '& .MuiSvgIcon-root': {
        //     fontSize: '1.5rem', 
        //     // color: 'rgba(0, 0, 0, 0.38)',
        //   },
        //   '& .MuiInputBase-root': {
        //     border: '1px solid rgba(0, 0, 0, 0.12)',
        //     borderRadius: '4px',
        //     paddingRight: '10px',
        //   },
        //   '& .MuiSelect-select': {
        //     paddingTop: '8px',
        //     paddingBottom: '8px',
        //   },
        //   '& .MuiTablePagination-selectLabel': {
        //     marginRight: '8px',
        //   },
        // }}
      />
    </GridFooterContainer>

  );
};

export default CustomFooter;
